export default __webpack_public_path__ + "e411d16dd981511af07a0276f8d81fd4.png";